import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { UpwardTransition } from 'src/utils';

import { clearLoggedInMessage } from '../actions/login';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { isMobile } from '../utils/MobileCheck';

/**
 * ログイン時メッセージ
 */
class LoginInitDialog extends React.Component<IProps> {
	public render() {
		const {
			displayDesktopMessageDialog,
			displayLastLoginInfo,
			displayLastLoginIPAddress,
			displaySecuritySamePwdWarningMessage,
			displayContentsLicenseInfoMessage,
			lastLoginFailedDateTime,
			lastLoginFailedIPAddress,
			lastLoginSuccessDateTime,
			lastLoginSuccessIPAddress,
			remainChangePwdExpireDateNum,
			lastCreatedFaildContentIds,
		} = this.props.loggedInMessage;

		// モバイルは非表示、デスクトップは表示
		const showDialog: boolean = isMobile()
			? false
			: displayDesktopMessageDialog &&
			  (displaySecuritySamePwdWarningMessage ||
					displayLastLoginInfo ||
					displayContentsLicenseInfoMessage);

		let passwordWarningMessage = i18n.t('LMCM_I_00513', { ns: 'message' });
		passwordWarningMessage = passwordWarningMessage.replace(
			'{0}',
			`${remainChangePwdExpireDateNum}`
		);
		let contentLicenseInfoMessage = i18n.t('LMCM_I_00667', {
			ns: 'message',
		});
		contentLicenseInfoMessage = contentLicenseInfoMessage.replace(
			'{0}',
			`${lastCreatedFaildContentIds}`
		);
		passwordWarningMessage = passwordWarningMessage + '<hr/>';

		const lastLoginFailedDateTimeDisp = lastLoginFailedDateTime
			? lastLoginFailedDateTime
			: i18n.t('LoggedInDialog_0001');
		const lastLoginFailedIPAddressDisp = lastLoginFailedIPAddress
			? lastLoginFailedIPAddress
			: i18n.t('LoggedInDialog_0002');
		const lastLoginSuccessDateTimeDisp = lastLoginSuccessDateTime
			? lastLoginSuccessDateTime
			: i18n.t('LoggedInDialog_0003');
		const lastLoginSuccessIPAddressDisp = lastLoginSuccessIPAddress
			? lastLoginSuccessIPAddress
			: i18n.t('LoggedInDialog_0004');
		return (
			<Dialog
				open={showDialog}
				TransitionComponent={UpwardTransition}
				keepMounted={true}
				onClose={this.onClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="alert-dialog-slide-title">
					{i18n.t('LoggedInDialog_0005')}
				</DialogTitle>
				<DialogContent>
					{displaySecuritySamePwdWarningMessage && (
						<DialogContentText
							id="alert-dialog-slide-description"
							dangerouslySetInnerHTML={{
								__html: passwordWarningMessage,
							}}
						/>
					)}
					{displayContentsLicenseInfoMessage && (
						<>
							<Typography
								variant="h6"
								color="inherit"
								style={{ marginBottom: 10 }}
							>
								{i18n.t('LoggedInDialog_0006')}
							</Typography>
							<DialogContentText
								id="alert-dialog-slide-description"
								dangerouslySetInnerHTML={{
									__html: contentLicenseInfoMessage,
								}}
								style={{ marginBottom: 15 }}
							/>
						</>
					)}
					{displayLastLoginInfo && (
						<>
							<Typography variant="h6" color="inherit">
								{i18n.t('LoggedInDialog_0007')}
							</Typography>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell />
										<TableCell>
											{i18n.t('LoggedInDialog_0008')}
										</TableCell>
										{displayLastLoginIPAddress && (
											<TableCell>
												{i18n.t('LoggedInDialog_0009')}
											</TableCell>
										)}
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow>
										<TableCell>
											{i18n.t('LoggedInDialog_0010')}
										</TableCell>
										<TableCell>
											{lastLoginSuccessDateTimeDisp}
										</TableCell>
										{displayLastLoginIPAddress && (
											<TableCell>
												{lastLoginSuccessIPAddressDisp}
											</TableCell>
										)}
									</TableRow>
									<TableRow>
										<TableCell>
											{i18n.t('LoggedInDialog_0011')}
										</TableCell>
										<TableCell>
											{lastLoginFailedDateTimeDisp}
										</TableCell>
										{displayLastLoginIPAddress && (
											<TableCell>
												{lastLoginFailedIPAddressDisp}
											</TableCell>
										)}
									</TableRow>
								</TableBody>
							</Table>
						</>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={this.onClose} color="primary">
						{i18n.t('LoggedInDialog_0012')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	/**
	 * ダイアログクローズ
	 */
	protected onClose = () => {
		this.props.clearLoggedInMessage();
	};
}

const mapStateToProps = (state: IRootState) => ({
	loggedInMessage: state.login.loggedInMessage,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearLoggedInMessage: () => dispatch(clearLoggedInMessage({})),
});

// tslint:disable-next-line: no-empty-interface
export interface ILoginInitDialogProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = ILoginInitDialogProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LoginInitDialog);

export default Connected;



// WEBPACK FOOTER //
// ./src/containers/LoggedInDialog.tsx